import { Button, LoaderButton } from 'components/Button';
import styles from './samplesAndOfferSection.scss';
import { hasElements, NO_ELEMENT, rm, withCurrentPage } from 'utils';
import { useDispatch, useSelector } from 'react-redux';
import { getOfferLink, getProductUrl, getSamples } from './selector';
import { GtmQuotationRequest } from 'store/googleTagManager/actions';
import { getProductTitle, getProductBrand } from 'views/ProductPage/selector';
import { useMutateCartAddSample } from '@bygghemmait/queries';
import { addSampleToCart } from 'components/Cart/actions';
import { selectShouldUseGecpHeader } from 'store/appShell/selector';

interface OwnProps {
  parentProductId: string;
}

export const SamplesAndOfferSection = ({ parentProductId }: OwnProps) => {
  const samples = useSelector(getSamples);
  const offerLink = useSelector(getOfferLink);
  const parentProductName = useSelector(withCurrentPage(getProductTitle));
  const productBrand = useSelector(withCurrentPage(getProductBrand));
  const productUrl = useSelector(getProductUrl);
  const reduxDispatch = useDispatch();
  const { mutateAsync: addSampleToCartGECP } = useMutateCartAddSample();
  const shouldUseGecpHeader = useSelector(selectShouldUseGecpHeader);

  const hasSamples = hasElements(samples);
  const hasOfferLink = Boolean(offerLink);

  if (!hasSamples && !hasOfferLink) {
    return NO_ELEMENT;
  }

  const add = (productId: string) => () => {
    if (shouldUseGecpHeader) {
      return addSampleToCartGECP({ productId, parentProductId });
    }

    return reduxDispatch(addSampleToCart({ productId, parentProductId }));
  };

  const offerClick = () =>
    reduxDispatch(GtmQuotationRequest(parentProductName, productUrl, productBrand));

  return (
    <div className={styles.base}>
      {hasSamples &&
        samples.map(sampleProduct => (
          <LoaderButton
            key={sampleProduct.productId}
            appearance="whitePill"
            onClick={add(sampleProduct.productId)}
            className={styles.button}
          >
            {rm('add_product_sample_to_cart')}
          </LoaderButton>
        ))}

      {hasOfferLink && (
        <Button
          href={offerLink}
          appearance="whitePill"
          className={styles.button}
          onClick={offerClick}
        >
          {rm('customerservice_question_quotation_label')}
        </Button>
      )}
    </div>
  );
};
